// extracted by mini-css-extract-plugin
module.exports = {"disabled":"_1WwrTG5y5-akOQuYMSCh53"};